import React, { useMemo } from "react";
import styled from "@emotion/styled";
// import Loader from "../../../components/icons/Loader";
import Checkbox from "../../../components/forms/QuestionnaireCheckbox";
import { useGetCurrentUserQuery } from "../../../api/users";
import { useUpsertAnswerMutation } from "../../../api/answers";
import {
  QuestionWithRelations,
  QuestionOption,
} from "../../../../../api/src/types";
// import useIsMobile from "../../../hooks/useIsMobile";
import {
  InputWrapper,
  ErrorWrapper /*IconContainer */,
} from "./SharedFormStyles";

const CheckboxContainer = styled.div`
  flex: 1;
`;

interface CheckboxInputProps {
  question: QuestionWithRelations;
  documentId: string;
}

const CheckboxInput: React.FC<CheckboxInputProps> = ({
  question,
  documentId,
}) => {
  // const isMobile = useIsMobile();
  const selectedOptionIds = useMemo(
    () =>
      question.answers[0]?.answerQuestionOptions.map(
        (a) => a.questionOptionId,
      ) ?? [],
    [question.answers],
  );
  /* id of the option whose save is in-flight */
  // const [pendingId, setPendingId] = useState<string | null>(null);

  const { data: user } = useGetCurrentUserQuery();
  const [
    upsertAnswer,
    {
      /*isLoading: isUpserting, */ isError: isUpsertError,
      reset: resetUpdateAnswer,
    },
  ] = useUpsertAnswerMutation();

  const hasError = isUpsertError;

  // Handle selection toggle
  const handleToggle = (optionId: string) => {
    resetUpdateAnswer();

    if (!user) return;

    const isCurrentlySelected = selectedOptionIds.includes(optionId);
    const newSelected = isCurrentlySelected
      ? selectedOptionIds.filter((id) => id !== optionId)
      : [...selectedOptionIds, optionId];

    const payload = {
      questionId: question.id,
      userId: user.id,
      documentId,
      rootQuestionId: question.rootQuestionId ?? question.id,
      sectionId: question.parentQuestionnaireSectionId,
      questionOptionIds: newSelected,
      serializeDebounceMs: 300,
    };

    void upsertAnswer(payload);
  };

  return (
    <>
      {question.questionOptions.map((option: QuestionOption) => {
        // Check if this option is selected
        const isChecked = selectedOptionIds.includes(option.id);
        // const isLoading = pendingId === option.id && (isCreating || isUpdating);

        return (
          <React.Fragment key={option.id}>
            <InputWrapper>
              <CheckboxContainer>
                <Checkbox
                  label={option.value}
                  id={option.id}
                  isChecked={isChecked}
                  onToggle={() => {
                    handleToggle(option.id);
                    // setPendingId(option.id);
                  }}
                  data-testid="checkbox-container"
                />
              </CheckboxContainer>
              {/* Commenting out the loader for now as per the request of the design team */}
              {/* {isLoading && (
                <IconContainer>
                  <Loader spinnerOnly={true} size={isMobile ? 16 : 34} />
                </IconContainer>
              )} */}
            </InputWrapper>
          </React.Fragment>
        );
      })}
      {hasError && (
        <ErrorWrapper>
          Error saving answer, please refresh the page and try again
        </ErrorWrapper>
      )}
    </>
  );
};

export default CheckboxInput;
